/** Banned in any AI reviewer label. "What to ask your doctor" is a separate string. */
export const BANNED_REVIEWER_WORDS = [
  "doctor",
  "physician",
  "therapist",
  "md",
  "врач",
  "доктор",
  "терапевт",
  "médico",
  "docteur",
  "médecin",
  "طبيب",
];

export function reviewerLabelContainsBannedWord(label) {
  const folded = String(label || "").toLocaleLowerCase();
  const deDotted = folded.replace(/\./g, "");
  return BANNED_REVIEWER_WORDS.some((word) => {
    const needle = word.toLocaleLowerCase();
    if (needle === "md") {
      return /(?:^|[^a-z])md(?:[^a-z]|$)/i.test(deDotted);
    }
    return folded.includes(needle);
  });
}

/**
 * Reviewer chip from persona specialty. Never display_name and never the model id.
 * Shape: "AI {specialty} advisor". Missing specialty, or a banned word in the
 * rendered label, uses the fallback.
 */
function specialtyFromPersonaId(personaId) {
  const raw = String(personaId || "").trim();
  if (!/^[a-z0-9_]+$/i.test(raw)) return "";
  return raw
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

/**
 * Specialty for a selected advisor. Prefers the value stored on the result,
 * then the catalog, then a readable form of a known persona id.
 */
export function specialtyForMember(member, personas = [], personaMap = {}) {
  const direct = String(member?.specialty || "").trim();
  if (direct) return direct;
  const personaId = member?.id || member?.persona_id;
  if (!personaId) return "";
  const known = (personas || []).find((persona) => persona?.id === personaId)
    || personaMap?.[personaId];
  const fromKnown = String(known?.specialty || "").trim();
  if (fromKnown) return fromKnown;
  if (known) return specialtyFromPersonaId(personaId);
  return "";
}

export function perspectiveLabel(specialty, t) {
  const spec = String(specialty || "").trim();
  const fallback = t("query.perspectiveFallback");
  if (!spec) return fallback;
  const label = t("query.perspectiveLabel").replace("{specialty}", spec);
  if (reviewerLabelContainsBannedWord(label)) return fallback;
  return label;
}

/** Council row when the used member is no longer in the persona catalog. */
export function unlistedCouncilMember(member) {
  return {
    id: member?.id,
    display_name: typeof member?.display_name === "string" ? member.display_name : "",
    specialty: typeof member?.specialty === "string" ? member.specialty : "",
    enabled: true,
    chairman_eligible: false,
  };
}

/**
 * Catalog specialty stays a perspective label.
 * A member missing from the catalog is named by display_name, then id.
 * The backing model id is not a name.
 */
export function councilMemberLabel(member, t) {
  const specialty = String(member?.specialty || "").trim();
  if (specialty) return perspectiveLabel(specialty, t);
  const identity = String(member?.display_name || member?.id || "").trim();
  if (identity) return identity;
  return perspectiveLabel("", t);
}
